import React from "react";
import client from "@culturehq/client";

import { useFetch } from "app/hooks";

import DefaultPanel from "components/display/DefaultPanel";
import ErrorPage from "components/ErrorPage";
import NotFound from "components/NotFound";
import Announcement from "components/featured/Announcement";

const AnnouncementCallout = ({ match }) => {
  const { error, fetching, json: { announcement } } = useFetch(
    () => client.getActiveAnnouncement({ announcementId: match.params.announcementId }),
    [match.params.announcementId]
  );

  if (error && error.status === 404) {
    return <NotFound />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <div className="max-width-900">
      {fetching ? <DefaultPanel /> : <Announcement widget={announcement} />}
    </div>
  );
};

export default AnnouncementCallout;
